<header>
    <div class="icon-back" (click)="back()">
        <mat-icon>arrow_back</mat-icon> 
    </div>
    <p class="header-tittle">Datos de contacto</p>
</header>
<app-navigation [currentStep]="6" [countSteppers]="7"></app-navigation>

<!-- Body -->
<form class="layout-form" [formGroup]="contactForm">
    <div class="component-content">
        <div class="header-text-container" [ngClass]="{'shadow-top': shadowScroll.showShadowTop}">
            <span class="header-text">
                Así te mantenemos al tanto de promos y entregas.
            </span>
        </div>
        <div class="scroll-display" (scroll)="onScroll($event)">
        <div class="form-select-content">
            <p class="input-label">Tu celular</p>
            <ng-container *ngIf="!phoneVerified; else verifiedPhone">
            <div class="phone-inputs-container" [class.phone-inputs-container--primary]="enablePhoneOtp">
                <div class="phone-country-selector" *ngIf="enablePhoneOtp">
                    <label class="input-label" id="phone-country-label">País</label>
                    <mat-select class="phone-code" formControlName="phoneCountry" aria-labelledby="phone-country-label" data-testid="phone-country">
                        <mat-select-trigger>
                            <img class="phone-flag" [src]="'assets/media/countriesFlags/' + selectedPhoneCountry.key + '.webp'" [alt]="selectedPhoneCountry.label">
                            {{ selectedPhoneCountry.code }}
                        </mat-select-trigger>
                        <mat-option *ngFor="let country of phoneCountries" [value]="country.key">
                            <img class="phone-flag" [src]="'assets/media/countriesFlags/' + country.key + '.webp'" [alt]="country.label">
                            {{ country.label }} {{ country.code }}
                        </mat-option>
                    </mat-select>
                </div>
                <app-text-input class="feature" [attr.data-testid]="'caract-cel'" [labelText]="enablePhoneOtp ? 'Código de área' : 'Cód. de Área'" [type]="enablePhoneOtp ? 'tel' : 'number'" [required]="!enablePhoneOtp || selectedPhoneCountry.key === 'AR'"
                requiredMessage="Ingresá tu código de área."
                [subText]="enablePhoneOtp ? '' : 'Incluir código de país y área'"
                formControlName="telephoneFeature" [submitted]="submitted || phoneVerificationAttempted" [placeholder]="!enablePhoneOtp ? '0351' : selectedPhoneCountry.key === 'AR' ? '351' : 'Opcional'"></app-text-input>

                <app-text-input class="number" [attr.data-testid]="'numero-cel'" [labelText]="'Número'" [type]="enablePhoneOtp ? 'tel' : 'number'" [required]="true"
                requiredMessage="Ingresá tu número."
                [subText]="enablePhoneOtp ? '' : 'Incluir código de país y área'"
                formControlName="telephoneNumber" [submitted]="submitted || phoneVerificationAttempted" [placeholder]="!enablePhoneOtp ? '151234567' : selectedPhoneCountry.key === 'AR' ? '5538489' : 'Número nacional'"></app-text-input>
            </div>
            <p *ngIf="enablePhoneOtp && (!(submitted || phoneVerificationAttempted) || phoneValid)" class="phone-input-hint">
                {{ selectedPhoneCountry.key === 'AR' ? 'Sin 0 ni 15. Ej.: 351 y 5538489.' : phoneLengthMessage }}
            </p>
            <div class="warning-label" *ngIf="(submitted || phoneVerificationAttempted) && validationLenthTelephone('principal')">
                {{ phoneLengthMessage }}
            </div>
            <div class="warning-label" *ngIf="(submitted || phoneVerificationAttempted) && (enablePhoneOtp ? contactForm.controls['telephoneFeature'].hasError('pattern') : contactForm.controls['telephoneFeature'].invalid)">
                {{ !enablePhoneOtp ? 'El código de área debe comenzar con el número 0.' : selectedPhoneCountry.key === 'AR' ? 'Ingresá un código de área de 2 a 4 dígitos, sin el 0 inicial.' : 'El código de área solo debe contener dígitos.' }}
            </div>
            <div class="warning-label" *ngIf="(submitted || phoneVerificationAttempted) && (enablePhoneOtp ? contactForm.controls['telephoneNumber'].hasError('pattern') : contactForm.controls['telephoneNumber'].invalid)">
                {{ !enablePhoneOtp ? 'El número de celular debe comenzar con el prefijo 15.' : selectedPhoneCountry.key === 'AR' ? 'Ingresá un número de 6 a 8 dígitos, sin agregar el prefijo 15.' : 'El número solo debe contener dígitos.' }}
            </div>
            <ng-container *ngIf="enablePhoneOtp">
                <button *ngIf="!phoneVerified" mat-raised-button class="verification-button" type="button" (click)="openOtp('phone')">Verificar celular</button>
                <p *ngIf="submitted && !phoneVerified" class="warning-label" role="alert">Verificá tu celular para continuar.</p>
            </ng-container>
            </ng-container>
            <ng-template #verifiedPhone>
                <div class="verification-success" role="status">
                    <mat-icon>check</mat-icon>
                    <div class="verified-contact"><strong>{{ displayedPhone }}</strong><span>Verificado</span></div>
                    <button mat-button type="button" (click)="changeContact('phone')">Cambiar</button>
                </div>
            </ng-template>
        </div>

        <div class="form-select-content">
            <p class="input-label">Tu email</p>
            <ng-container *ngIf="!emailVerified; else verifiedEmail">
            <app-text-input [attr.data-testid]="'input-email'" [labelText]="'Email del Comercio o Titular'" [type]="'email'" [subText]="'Ingrese una dirección válida'" [required]="true"
            requiredMessage="Ingresá tu email del comercio o titular."
            formControlName="email" [submitted]="submitted || emailVerificationAttempted" [placeholder]="'nombre@minegocio.com'"></app-text-input>
            <p class="warning-label" *ngIf="(submitted || emailVerificationAttempted) && contactForm.controls['email'].hasError('maxlength')">
                El email no debe superar los 50 caracteres.
            </p>
            <ng-container *ngIf="enableEmailOtp">
                <button *ngIf="!emailVerified" mat-raised-button class="verification-button" type="button" (click)="openOtp('email')">Verificar email</button>
                <p *ngIf="submitted && !emailVerified" class="warning-label" role="alert">Verificá tu email para continuar.</p>
            </ng-container>
            </ng-container>
            <ng-template #verifiedEmail>
                <div class="verification-success" role="status">
                    <mat-icon>check</mat-icon>
                    <div class="verified-contact"><strong>{{ contactForm.controls['email'].value }}</strong><span>Verificado</span></div>
                    <button mat-button type="button" (click)="changeContact('email')">Cambiar</button>
                </div>
            </ng-template>
        </div>

        <div class="form-select-content premises-phone-section">
            <p id="premises-phone-label" class="input-label">¿Es el celular que usás en el local?</p>
            <div class="premises-phone-options" role="group" aria-labelledby="premises-phone-label">
                <button mat-stroked-button type="button" [attr.aria-pressed]="contactForm.controls['samePhoneAtPremises'].value === 'yes'"
                    (click)="contactForm.controls['samePhoneAtPremises'].setValue('yes')">
                    <span class="premises-option-copy"><strong>Sí, es el del local</strong><span>Lo usamos para coordinar la entrega.</span></span>
                    <span class="premises-option-check" *ngIf="contactForm.controls['samePhoneAtPremises'].value === 'yes'">
                        <mat-icon>check</mat-icon>
                    </span>
                </button>
                <button mat-stroked-button type="button" [attr.aria-pressed]="contactForm.controls['samePhoneAtPremises'].value === 'no'"
                    (click)="contactForm.controls['samePhoneAtPremises'].setValue('no')">
                    <span class="premises-option-copy"><strong>No, hay otro número</strong><span>Sumá un teléfono de contacto.</span></span>
                    <span class="premises-option-check" *ngIf="contactForm.controls['samePhoneAtPremises'].value === 'no'">
                        <mat-icon>check</mat-icon>
                    </span>
                </button>
            </div>
        </div>

        <div class="form-select-content" *ngIf="contactForm.controls['samePhoneAtPremises'].value === 'no'">
            <label class="input-label">Teléfono del local</label>
            <div class="phone-inputs-container">
                <app-text-input  [attr.data-testid]="'caract-cel-secundario'"  class="feature" [labelText]="'Cód. de Área'" [type]="'telephone-feature'"  [subText]="'Incluir código de país y área'" [required]="true"
                formControlName="secondaryTelephoneFeature" [type]="'number'" [submitted]="submitted" [placeholder]="'0351'" [complementaryFieldText]="contactForm.controls['secondaryTelephoneNumber'].value"></app-text-input>

                <app-text-input  [attr.data-testid]="'numero-cel-secundario'"  class="number" [labelText]="'Número de contacto'" [type]="'telephone-number-optional'"  [subText]="'Incluir código de país y área'" [required]="true"
                formControlName="secondaryTelephoneNumber" [type]="'number'" [submitted]="submitted" [placeholder]="'481000'" [complementaryFieldText]="contactForm.controls['secondaryTelephoneFeature'].value"></app-text-input>
            </div>
            <div class="warning-label" *ngIf="submitted && validationLenthTelephone('optional')">
                Longitud del número de comercio inválido (11 dígitos)
            </div>
            <div class="warning-label" *ngIf="submitted && contactForm.controls['secondaryTelephoneFeature'].invalid">
                Ingresá un código de área de 3 a 5 dígitos que comience con 0.
            </div>
            <div class="warning-label" *ngIf="submitted && contactForm.controls['secondaryTelephoneNumber'].invalid">
                Ingresá un número de contacto de 6 a 8 dígitos.
            </div>
        </div>

        <div class="form-select-content store-photos-section">
            <p class="input-label store-photos-title"><strong>Fotos del comercio</strong> <span>(opcional)</span></p>
            <div class="store-photo-uploads">
                <div class="store-photo-row" *ngFor="let file of files; let i = index">
                    <mat-icon class="store-photo-icon" aria-hidden="true">photo_camera</mat-icon>
                    <app-file-upload-component class="contact-photo-upload" [attr.data-testid]="'subida-archivo'"
                    [labelText]="i === 0 ? 'Interior del comercio' : 'Exterior del comercio'" [isImg]="file.isImg"
                    [extensions]="file.extensions" [subtitle]="i === 0 ? 'Adjuntá una foto del interior.' : 'Así el repartidor te encuentra más fácil.'" [documentId]="file.documentId" [formControlName]="'uploadFile' + i" [maxSizeFile]="file.size" [id]="'file' + i"></app-file-upload-component>
                </div>
            </div>
        </div>

        <div class="form-select-content delivery-time-section">
            <p class="input-label">Horarios de entrega</p>
            <p class="delivery-time-description">Elegí en qué horarios podés recibir. Con una franja alcanza.</p>
            <p class="input-label">Mañana</p>
            <div class="time-picker--content">
                <label class="time-picker-field">
                    <span class="label-time">Desde</span>
                    <app-time-picker [placeholder]="'Elegí'" [attr.data-testid]="'picker-franja-mañana-inicio'" [timeTo]="timeA.end" [timeFrom]="timeA.start" [sumeTime]="sumeTime" [submitted]="submitted" formControlName="timeAStart"></app-time-picker>
                </label>
                <span class="time-picker--separator">-</span>
                <label class="time-picker-field">
                    <span class="label-time">Hasta</span>
                    <app-time-picker [placeholder]="'Elegí'" [attr.data-testid]="'picker-franja-mañana-final'"  [timeTo]="timeA.end" [timeFrom]="timeA.start" [sumeTime]="sumeTime" [submitted]="submitted" formControlName="timeAEnd"></app-time-picker>
                </label>
            </div>
            <div class="warning-label" *ngIf="!validationPicker(this.contactForm.controls['timeAStart'].value, this.contactForm.controls['timeAEnd'].value,
            this.contactForm.controls['timeAStart'].dirty, this.contactForm.controls['timeAEnd'].dirty )">
                Horario inválido
            </div>
        </div>
        <div class="form-select-content delivery-time-section">
            <p class="input-label">Tarde</p>
            <div class="time-picker--content">
                <label class="time-picker-field">
                    <span class="label-time">Desde</span>
                    <app-time-picker [placeholder]="'Elegí'" [attr.data-testid]="'picker-franja-tarde-inicio'" [sumeTime]="sumeTime" [timeTo]="timeB.end" [timeFrom]="timeB.start" [submitted]="submitted" formControlName="timeBStart"></app-time-picker>
                </label>
                <span class="time-picker--separator">-</span>
                <label class="time-picker-field">
                    <span class="label-time">Hasta</span>
                    <app-time-picker [placeholder]="'Elegí'" [attr.data-testid]="'picker-franja-tarde-final'" [sumeTime]="sumeTime" [timeTo]="timeB.end" [timeFrom]="timeB.start" [submitted]="submitted" formControlName="timeBEnd"></app-time-picker>
                </label>
            </div>
            <div class="warning-label" *ngIf="!validationPicker(this.contactForm.controls['timeBStart'].value, this.contactForm.controls['timeBEnd'].value,
            this.contactForm.controls['timeBStart'].dirty, this.contactForm.controls['timeBEnd'].dirty )">
                Horario inválido
            </div>
            <div class="warning-label" *ngIf="submitted && sumeTime < 4">
                La suma de la franja horaria A y B debe ser mayor a 4 horas.
            </div>
        </div>
        <div class="form-checkbox">
            <mat-checkbox [attr.data-testid]="'check-terminos-condiciones'" formControlName="conditionsAndTerms"></mat-checkbox>
            <p class="form-checkbox--text" >
                <span> Acepto los </span>
                <span class="form-terms-conditions" (keydown)="openTermsDialogOnKeyDown($event)" (click)="openTermsDialog()"> términos y condiciones</span> 
            </p>
        </div>
        <div class="warning-label" *ngIf="submitted  && !this.contactForm.controls['conditionsAndTerms'].valid">
            Debes acceptar los términos y condiciones.
        </div>
        </div>
    </div>
</form>

<!-- Footer -->

<div class="button-container">
  <button mat-raised-button class="next-button" (click)="onSubmit()">Continuar</button>
</div>
